import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import moment from 'moment';
import { Moment } from 'moment';

import { AutoNumericDirective } from '../../../directives/auto-numeric.directive';
import { BaseUI } from '../../base.ui';
import { ContractInterface, OrderAction, ProductInterface, SelectedProductInterface, TypeOfWithdraw } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';
import { Id } from 'src/app/main/domain/data';

@Component({
    selector: 'thr-operate-refund-period',
    templateUrl: './operate-refund-period.component.html',
    styleUrls: ['./operate-refund-period.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class OperateRefundPeriodComponent extends BaseUI implements AfterViewInit, OnDestroy, OnInit {
    public OrderAction: typeof OrderAction = OrderAction;
    public TypeOfWithdraw: typeof TypeOfWithdraw = TypeOfWithdraw;

    public initialShares;
    public initialAmount;

    @Input()
    editable = true;

    @Input()
    contract: ContractInterface;

    @Input()
    product: ProductInterface;

    @Input()
    selectedProduct: SelectedProductInterface;

    @ViewChild('sharesDirective')
    sharesDirective: AutoNumericDirective;

    @ViewChild('amountDirective')
    amountDirective: AutoNumericDirective;

    @ViewChild('sharesInput')
    sharesInput: ElementRef;

    @Input()
    canExonerate = false;

    @Output()
    detail: EventEmitter<Id> = new EventEmitter();

    @Output()
    exonerate: EventEmitter<Id> = new EventEmitter();


    constructor(parentEvents: ParentEvents, private cdr: ChangeDetectorRef) {
        super(parentEvents);
    }

    ngOnInit() {
        this.initialShares = this.selectedProduct.order.shares || 0;
        this.initialAmount = this.selectedProduct.order.amount || 0;
        this.cdr.detectChanges();

        if (this.editable) {
            this.onActionChange();
        }
    }

    get maximumInvestment(): number {
        if (this.product) {
            if (this.selectedProduct.order.action === OrderAction.AMOUNT) {
                const max = Number((this.selectedProduct.amount - this.product.minimumAmountToMaintain).toFixed(2));
                return max || 0;
            } else {
                return null;
            }
        }

        return 0;
    }

    get maximumShares(): number {
        if (this.product) {
            if (this.selectedProduct.order.action === OrderAction.SHARES) {
                const sharePrice = this.selectedProduct.amount / this.selectedProduct.shares;
                const minimumSharesToMaintain = this.product.minimumAmountToMaintain / sharePrice;
                const max = Number((this.selectedProduct.shares - minimumSharesToMaintain).toFixed(8));
                return max || 0;
            } else {
                return null;
            }
        }

        return 0;
    }

    get minStartDate(): Date {
        const min = moment().add(1, 'days');
        if (min.isoWeekday() === 6 || min.isoWeekday() === 7) {
            min.weekday(7);
        }
        return min.toDate();
    }

    filterWeekend = (d: Moment): boolean => {
        return d && d.isoWeekday() !== 6 && d.isoWeekday() !== 7;
    };

    onActionChange() {
        this.selectedProduct.order.typeOfWithdraw = undefined;
        this.selectedProduct.order.amount = 0;
        this.selectedProduct.order.shares = 0;
        this.cdr.detectChanges();

        switch (this.selectedProduct.order.action) {
            case OrderAction.SHARES:
                this.selectedProduct.order.withShares = true;
                this.onSharesChange();
                break;
            case OrderAction.AMOUNT:
                this.selectedProduct.order.withShares = false;
                this.onAmountChange();
                break;
        }

        this.parentEvents.resize();
    }

    onResize() {
        this.parentEvents.resize();
    }

    onSharesChange() {
        setTimeout(() => {
            if (this.sharesDirective) {
                this.selectedProduct.order.shares = this.sharesDirective.value;
            }

            const sharePrice = this.selectedProduct.amount / this.selectedProduct.shares;
            this.selectedProduct.order.amount = Number((this.selectedProduct.order.shares * sharePrice).toFixed(2));

            if (this.amountDirective) {
                this.amountDirective.value = this.selectedProduct.order.amount;
            }

            this.cdr.detectChanges();
        });
    }

    onAmountChange() {
        setTimeout(() => {
            if (this.amountDirective) {
                this.selectedProduct.order.amount = this.amountDirective.value;
            }

            const sharePrice = this.selectedProduct.amount / this.selectedProduct.shares;
            this.selectedProduct.order.shares = sharePrice ? Number((this.selectedProduct.order.amount / sharePrice).toFixed(6)) : 0;

            if (this.sharesDirective) {
                this.sharesDirective.value = this.selectedProduct.order.shares;
            }

            this.cdr.detectChanges();
        });
    }

    onExonerate() {
        this.exonerate.emit(this.product.id as Id);
    }
}
